import type { Distance } from "@pdfking/math"
import { Total } from "@pdfking/math"

import type { FolderShape } from "#internal"

import { FolderCreases } from "./FolderCreases"

/** The spine of a folder from `x` to `x + spine`, its folds from `top` to
 * `bottom` — a third down its middle with `middle`. */
export const FolderSpine = (
  x: Distance,
  top: Distance,
  bottom: Distance,
  spine: Distance,
  middle = false
): FolderShape => {
  const outer = Total(x, spine)
  return {
    corners: [],
    cut: [],
    fold: FolderCreases(
      [
        { x, y: top },
        { x, y: bottom },
      ],
      [
        { x: outer, y: top },
        { x: outer, y: bottom },
      ],
      middle
    ),
  }
}
